export type NoteCategory = 'inspiration' | 'todo' | 'mood' | 'memo' | 'review';

export const NOTE_CATEGORIES: NoteCategory[] = ['inspiration', 'todo', 'mood', 'memo', 'review'];

export const CATEGORY_LABEL: Record<NoteCategory, string> = {
  inspiration: '灵感',
  todo: '待办',
  mood: '心情',
  memo: '备忘',
  review: '复盘',
};

export interface AiInsight {
  headline?: string;
  evidence?: string[];
  next_step?: string;
  raw_md?: string | null;
  confidence?: number | null;
  is_valid?: boolean;
}

export interface NoteImageAsset {
  media_id: string;
  media_key: string;
  signed_url?: string | null;
  mime_type?: string | null;
  file_size?: number | null;
  status?: string | null;
  created_at?: string;
}

export interface Note {
  id: string;
  title: string;
  content: string;
  category: NoteCategory;
  transcript: string | null;
  audio_url: string | null;
  is_text_input: boolean;
  key_points: string[] | null;
  tags: string[] | null;
  emotion: unknown;
  llm_confidence: number | null;
  refine_code: number | null;
  user_edited: boolean;
  /** Backend returns an object; some legacy responses returned markdown string. */
  ai_insight: AiInsight | string | null;
  ai_insight_status: string | null;
  ai_insight_updated_at: string | null;
  feedback_md: string | null;
  feedback_updated_at: string | null;
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
  deleted_at: string | null;
  continued_from_id: string | null;
  image_urls: string[] | null;
  image_assets: NoteImageAsset[] | null;
  media_status: string | null;
}

/** Normalize ai_insight into the structured shape. Handles legacy string. */
export function toAiInsight(x: Note['ai_insight']): AiInsight | null {
  if (!x) return null;
  if (typeof x === 'string') return { raw_md: x, is_valid: true };
  return x;
}

/** Get the best image URLs to show (prefer signed urls from image_assets). */
export function resolveImageUrls(note: Note): string[] {
  const fromAssets = (note.image_assets ?? [])
    .map((a) => a.signed_url)
    .filter((u): u is string => typeof u === 'string' && u.length > 0);
  if (fromAssets.length > 0) return fromAssets;
  return note.image_urls ?? [];
}

export interface NoteListResponse {
  items: Note[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}
